module.exports = __webpack_public_path__ + "static/masterclass-58c3911001ce81bdd0e2111e32b5deea.png";